// @ts-ignore
import React, { useState, useEffect, useMemo, useRef } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';

import { withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import {
  WithStyles,
  createStyles,
  Typography,
  Grid,
  ListItemText,
  MenuItem,
  Button,
  Dialog,
  FormControlLabel,
  Checkbox,
  ClickAwayListener,
} from '@material-ui/core';
import { MyPATExpansionPanel, MyPATMultiSearch, MyPATSelect } from '../../../common';
import Link from '@material-ui/core/Link';
import Error from '@material-ui/icons/Error';
import contentService from '../../services/contentService';
import {
  Course,
  CourseType,
  QuestionBenchmarkItem,
  QuestionBenchmarks,
  QuestionBenchmarkError,
  AllQuestionBenchmarks,
} from '../../types/Benchmarks';
import { GoalLevel } from '../../../goal-management/types/GoalLevel';
import goalManagementService from '../../../goal-management/services/goalManagementService';
import { questionActions } from '../../reducers/questionCreateReducer';
import { validateQuestionBenchmarks } from '../../../../utils';
import CustomInfoIcon from '../../../common/CustomInfoIcon';
import {PreviousExamItem} from '../../types/PreviousYearsQuestion';
import Select from "react-select";
import { CONTENT_SPECIAL_PURPOSES } from '../../../../constants/comman';
const styles = (theme: Theme) =>
  createStyles({
    mb2x: {
      marginBottom: theme.spacing.unit * 2,
    },
    mt2x: {
      marginTop: '-26px',
    },
    dialogWidth: {
      // width: 960,
      height: 'auto',
    },
    capitalizeText: {
      textTransform: 'capitalize',
    },
    cardHeading: {
      fontWeight: theme.typography.fontWeightRegular,
    },
    requiredHeading: {
      color: theme.palette.secondary.main,
    },
    hintBox: {
      marginTop: '24px',
      border: `1px solid ${theme.palette.grey[300]}`,
      borderRadius: theme.shape.borderRadius,
      padding: theme.spacing.unit,
      '& textarea': {
        border: 0,
        padding: 0,
      },
      '& h6': {
        color: theme.palette.grey[400],
      },
      '& .suggested-box': {
        background: theme.palette.common.white,
        border: `1px solid ${theme.palette.grey[300]}`,
        borderRadius: theme.shape.borderRadius,
        padding: theme.spacing.unit,
        width: '100%',
        marginBottom: theme.spacing.unit,
        '&:last-child': {
          marginBottom: 0,
        },
      },
    },
    greyText: {
      color: '#999',
    },
    deleteButton: {
      display: 'flex',
      alignItems: 'flex-end',
      cursor: 'pointer',
      height: '100%',
      paddingBottom: 10,
    },

    dialogFooter: {
      marginTop: '38px',
      '& p': {
        fontSize: '20px',
      },
      '& p:nth-of-type(2)': {
        fontSize: '14px',
      },
    },
    dialogHeader: {
      marginTop: '38px',
      '& p': {
        fontSize: '20px',
      },
      '& p:nth-of-type(2)': {
        fontSize: '14px',
      },
    },
    divider_or: {
      width: '100%',
      position: 'relative',
      display: 'block',
      height: '25px',
      margin: '15px 0',
      '&::before': {
        content: "''",
        height: '1px',
        background: '#E4E4E4',
        position: 'absolute',
        left: 0,
        top: '14px',
        zIndex: 8,
        width: '100%',
      },
      '&::after': {
        content: "'OR'",
        height: '26px',
        width: '26px',
        background: '#E4E4E4',
        fontWeight: 700,
        fontSize: '10px',
        lineHeight: '27px',
        color: '#989898',
        position: 'absolute',
        left: '50%',
        marginLeft: '-13px',
        top: 0,
        zIndex: 9,
        textAlign: 'center',
        fontStyle: 'italic',
        borderRadius: '50%',
      },
    },
    displayFlexbox: {
      display: 'flex',
      justifyContent: 'flex-end',
      '& button': {
        marginTop: '24px',
      },
    },
    dialogHeightFix: {
      maxHeight: 'initial',
    },
    dialogPaper: {
      maxWidth: '960px',
      maxHeight: 'initial',
      padding: '20px',
      width: '100%',
    },
    errorText: {
      color: '#333',
      verticalAlign: 'middle',
      marginTop: '3px',
      fontSize: "12px !important",
      display: "flex",
      alignItems: "center",
      fontWeight: 400,
      '& svg': {
        verticalAlign: 'bottom',
        fontSize: "14px !important",
        marginRight: '5px',
        fill: '#1d7dea',
      },
    },
    benchTitle: {
      padding: '16px',
      maxHeight: '290px',
      // overflow: 'auto',
    },
    customLink: {
      padding: 0,
    },
    // customSelect: {
    menuPaper: {
      maxHeight: 100,
    },
    // },
    okButton: {
      fontFamily: 'Nunito',
      fontStyle: 'normal',
      fontWeight: 600,
      fontSize: 14,
      lineHeight: '19px',
      letterSpacing: '0.5px',
      color: '#FFFFFF',
      background: '#1D7DEA',
      padding: '4px 22px',
      width: 188,
      borderRadius: 4,
      '&:hover': {
        background: '#1D7DEA',
      },
    },
    headingTxt:{
      fontSize: 16,
      color: '#333',
      textAlign: 'center',
      marginBottom: 12,
      marginTop: 12,
    },
    subTxt:{
      '&>ul':{
        paddingLeft: 15,
        '&>li':{
          fontSize: 14,
          color: '#333',
          textAlign: 'left',
          marginBottom: 9,
        }
      },
    },
    blankEntry: {
      '& :focus': {
        background: 'none',
      },
      outline: 'none'
    },
    optionContainer: {
      "& input": {
        border: "1px solid #DFDFDF",
        width: "100%",
        padding: "10px",
      },
    },
    optionlistContainer: {
      position: "relative",
      "&::after": {
        top: "5px",
        right: "18px",
        border: "solid rgb(0 0 0 / 0%)",
        height: 0,
        content: '" "',
        zIndex: 999,
        position: "absolute",
        transform: "rotate(226deg)",
        boxShadow: "1px 1px 1px #DFDFDF",
        background: "rgb(255 255 255)",
        borderColor: "rgb(194 225 245 / 0%)",
        borderWidth: 9,
        borderBottomColor: "rgb(255 255 255)",
      },
    },
    optionList: {
      width: "100%",
      border: "1px solid #DFDFDF",
      display: "block",
      padding: "10px",
      position: "absolute",
      backgroundColor: "#fff",
      top: "13px",
      borderRadius: "7px",
      maxHeight: 150,
      overflowX: "hidden",
      overflowY: "auto",
      zIndex: 2,
      "& input": {
        marginTop: 10,
        paddingLeft: 40,
      },
      "& span": {
        display: "block",
        padding: '2px 5px'
      },
    },
    customReactSelect:{
      '& > div+div > div': {
        height: '150px'
      },
      '& .css-1okebmr-indicatorSeparator':{
        background: 'transparent',
      }

    },
    optionalText: {
      fontSize: '20px',
      color: '#999999',
    }
  });

interface PreviousYearQuestionProps extends WithStyles<typeof styles> {
  subjects: any[];
  questionId: string;
  allQuestionBenchmarks: AllQuestionBenchmarks;
  setQuestionBenchmarks: any;
  editQuestionBenchmarks: any;
  removeAllQuestionBenchmarks: any;
  setForceQuestionBenchmarkUpdate: any;
  addQuestionBenchmarkField: any;
  removeQuestionBenchmarkField: any;
  setQuestionBenchmarkErrors: any;
  resetQuestionBenchmarks: any;
  initialiseQuestionBenchmarks: any;
  relevantExams: any;
  isDisable: boolean;
  allRelevantExams:any;
  questionPreviousExams: { [key :string ]:PreviousExamItem []};
  setPreviousExams:Function;
  classes:any;
  questionSpecialPurposes: any;
  allPreviousExams: any;
  handlePreviousExams?: Function;
  defaultExpanded?: boolean;
}

interface GoalLevelsState {
  [courseId: string]: GoalLevel[];
}
interface idYearMap{
  [questionId:string]: {
    show:boolean,
    year:number[]
  }
}

const otherDialogProps = {
  fullWidth: false,
  maxWidth: false,
  body: 'paper',
};
function getCourseList (allData: any, questionSpecialPurposes: any){
  let courseListData;
  courseListData = allData && allData.map((course: any) => {
    if (questionSpecialPurposes.includes(CONTENT_SPECIAL_PURPOSES.FTRE)) {
      return {
        id: course._id,
        name: course.name,
      }
    }
    return course.courseType
  });
  return courseListData;
};

function PreviousYearQuestion(props: PreviousYearQuestionProps) {
  const previousRelevantExamsLength = useRef(0);
  const [targetExams,setTargetExams]= useState([]);
  // const [courseIdYearMap,setCourseIdYearMap]=useState<idYearMap>({}); 
  const[showYearIndex,setYearIndx]=useState(-1); 
  const {
    subjects,
    classes,
    questionId,
    allRelevantExams,
    questionPreviousExams,
    setPreviousExams,
    allPreviousExams,
    handlePreviousExams,
    defaultExpanded
  } = props;
  const currentYear=new Date().getFullYear() 
  const yearsArray= Array(13).fill(undefined).map((_, idx) => currentYear-(idx+1));
  useEffect(() => {
    const allExams = props.questionSpecialPurposes.includes(CONTENT_SPECIAL_PURPOSES.FTRE) ? allPreviousExams : allRelevantExams;
    const courseListData = getCourseList(allExams, props.questionSpecialPurposes);
    const alreadySelected=(questionPreviousExams[questionId]||[]).map((ele:any)=>{
        return ele.id;
    });
    const optionList:any[] = [];

    courseListData.forEach(({name, id}:any)=>{
        if(!alreadySelected.includes(id)){
           optionList.push({
            label: name,
            value: id,
            id,
         });
        };
    });
    setTargetExams(optionList);
  }, [questionId, allPreviousExams, allRelevantExams,questionPreviousExams[questionId]]);


  const handleExpansion = () => {
    // setExpanded((prevOpen: Boolean) => !prevOpen);
    // const { hasErrors, errors } = validateQuestionBenchmarks(benchmarks);
    // if (hasErrors) {
    //   setQuestionBenchmarkErrors({ questionId, data: errors });
    // }
  };

  const hasErrorInAnyRow = () => {
    let result=questionPreviousExams[questionId] &&
                questionPreviousExams[questionId].find((ele)=> { return ele.error===true;}
      );
    return result?true:false; 
  };

  const showAddMoreButton = true;
  return (
    <>
      <MyPATExpansionPanel
        defaultExpanded={defaultExpanded}
        sectionId={"previousYearQuestion"}
        // panelProps={{
        //   expanded,
        //   onChange: handleExpansion,
        // }}
        variant="white"
        hasExpandIcon
        customCollapseTitle={
          <Grid container justify="space-between">
            <Grid item>
            <Typography onClick={(event) => {event.stopPropagation();}} variant="h6" className={classes.cardHeading}>
              Previous Year Question&nbsp;
              <span className={classes.optionalText}>  (Optional)</span>
              <CustomInfoIcon
                infoDialogContentType="Goal Management"
                isInfoIcon={true}
                isRightArrow={false}
                isCenterArrow={true}
                knowMoreAbout={false}
                dialogTitle="Previous Year Questions"
                imageURL="/assets/svg/infoIcon/previousYear.svg"
                dialogPara="Tag the Exam and year if the added question has appeared in any of the previous year paper"
                details="Click to know more"
                toolTipDirection="top" />
            </Typography>
            </Grid>

            <Grid item>
            {hasErrorInAnyRow() && (
              <Typography
                className={classes.errorText}
                variant="caption"
                color="error"
              >
                <img src="/assets/svg/contentRequest/blueInfo.svg"/>&nbsp;
                 Select atleast one year under Previous Year Question Section
              </Typography> 
            )}
            </Grid>

          </Grid>
          // )
        }
        isDisable={props.isDisable}
      >
        {renderFields()}
      </MyPATExpansionPanel>
      {/* {renderRemovedBenchmarkInfoPopup()} */}
      {/* {forceBenchmarkUpdate && relevantExams.length > 0 && (
        <Dialog classes={{ paper: classes.dialogPaper }} open={true}>
          <Grid className={classes.dialogWidth}>{renderDialogContent()}</Grid>
        </Dialog>
      )} */}
    </>
  );
  function handleTargetExamSelection({id,label,value}:any,index:number){
    let newPreviousExam:PreviousExamItem []=[];
      if(Array.isArray(questionPreviousExams[questionId])){
        newPreviousExam=[...questionPreviousExams[questionId]]; 
      }
      if(newPreviousExam.length<index){
        newPreviousExam.push({name:label,id,year:[]});
      }else{
        newPreviousExam[index]={name:label,id,year:[]};
      }
       setPreviousExams({questionId:questionId,data:newPreviousExam}); 
       handlePreviousExams && handlePreviousExams(newPreviousExam);
  }

  function handleAdditionOfYearRow(){
    let emptyRow={id:'',year:[],name:''};
    let newPreviousExam:PreviousExamItem []=[];
    
    newPreviousExam=[...questionPreviousExams[questionId],emptyRow];

    setPreviousExams({questionId:questionId,data:newPreviousExam});  
    handlePreviousExams && handlePreviousExams(newPreviousExam)
  }

  function handleYearChange(event:any,index:number){
     const {name,value,checked}=event.target;
     let newPreviousExam:PreviousExamItem []=[...questionPreviousExams[questionId]];
     let currentRow={...newPreviousExam[index]};
     let newYear= [...currentRow.year];
     if(!checked){
       let indx=newYear.indexOf(value);
       newYear.splice(indx,1);
     }
     else{
      newYear=[...newYear,value]; 
     }
     if(currentRow.error){
        currentRow.error =newYear.length>0?false:true;
     }
      currentRow.year=newYear;
      newPreviousExam[index]=currentRow;
      setPreviousExams({questionId:questionId,data:newPreviousExam}); 
      handlePreviousExams && handlePreviousExams(newPreviousExam);
  }
  function handleDeletionOfBenchmarkRow(indx:number){
    let newPreviousExam:PreviousExamItem []=[...questionPreviousExams[questionId]];
    newPreviousExam.splice(indx,1);
    if(newPreviousExam.length==0){
      newPreviousExam.push({id:'',name:'',year:[]});
    }
    setYearIndx(-1);
    setPreviousExams({questionId:questionId,data:newPreviousExam}); 
    handlePreviousExams && handlePreviousExams(newPreviousExam);
  }
  function renderFields() {

    let courseId = '';
    let currentGoalLevels:any = [];
    // let targetExamList = previousExams.map(({ id, name }: CourseType) => {
    //   return (
    //     <MenuItem key={id} value={id}>
    //       <ListItemText primary={name} />
    //     </MenuItem>
    //   );
    // })
    // targetExamList.unshift(
    //   <li className={classes.blankEntry}>
    //     <MenuItem id={''} value={''}>
    //   <ListItemText primary='Select Target Exam' />
    // </MenuItem>
    // </li>
    // )
    const allPreviousExams:any []=_.get(questionPreviousExams,`[${questionId}]`,[{id:'',name:'',year:[]}]);
    return (
       
      <div className={[classes.hintBox].join(' ')}>
        {allPreviousExams.map(
          (
            { year,id,
              name,error },
            index: number
          ) => {
            const showDeleteButton = !(allPreviousExams.length==1 && id==='');
            return (
              <Grid container spacing={24} key={index}>
                <Grid item xs={6}>
                  {index===0 && <Typography variant="body1" gutterBottom>
                    Target Exam
                  </Typography>}
                <Grid> 
                <Select
                // inputValue={name}
                defaultValue={id}
                // components={{IndicatorsContainer:() => null }}
                value={id ? {label:name, value:id} : null}
                onChange={(e:any)=>{handleTargetExamSelection(e,index)}}
                options={targetExams}
                placeholder={`Search Exam here`}
                className={classes.customReactSelect}
                // onFocus={() => {
                //   this.handleFocus(tagData, fieldData);
                //   setSectionFocus(true)
                // }}
                // onBlur={() => {
                //   setSectionFocus(false)
                // }}
                // onInputChange={this.onInputChange.bind(this)} //the function to handle our search input
                blurInputOnSelect={true}
              />
                {/* <img src="/assets/svg/myLibrary/search-icon.svg" /> */}
              </Grid>
                </Grid>
                <Grid item xs={5}>
                  {index===0 && <Typography variant="body1" gutterBottom>
                   Year
                  </Typography>}
              <div className={classes.optionContainer}>
                <div
                >
              <input
                type="text"
                placeholder="Select Year"
                value={allPreviousExams[index].year.join(',')}
                disabled={!(allPreviousExams[index] && allPreviousExams[index].id)}
                onClick={() => {
                  setYearIndx(showYearIndex==index?-1:index)
                }}
               />
              </div>
            {showYearIndex==index && (
             <ClickAwayListener onClickAway={()=>{setYearIndx(-1)}}> 
             <div className={classes.optionlistContainer}>
              <div className={classes.optionList}>
                {yearsArray.map((y) => (
                   <span>
                   <FormControlLabel
                     control={
                       <Checkbox
                         checked={year.includes(""+y)}
                         onChange={(e)=>{handleYearChange(e,index)}}
                         name={id}
                         color="primary"
                       />
                     }
                     label={y}
                     key={id+''+y}
                     value={""+y}
                   />
                 </span>
                  ))}
              </div>
              </div>
              </ClickAwayListener>
            )}
            
          </div>
                </Grid>
                <Grid item xs={1}>
                  {showDeleteButton && (
                    <div
                      className={classes.deleteButton}
                      onClick={() => handleDeletionOfBenchmarkRow(index)}
                    >
                      <img src="/assets/svg/delete.svg" alt="Delete" />
                    </div>
                  )}
                </Grid>
              </Grid>
            );
          }
        )}
        {showAddMoreButton && (
          <Grid container spacing={24}>
            <Grid item xs={6}>
              <Link
                className={classes.customLink}
                component="button"
                variant="body2"
                onClick={handleAdditionOfYearRow}
              >
                + Add More
              </Link>
            </Grid>
          </Grid>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    allQuestionBenchmarks: state.questionCreate.questionBenchmarks,
    relevantExams: state.questionCreate.relevantExams,
    allRelevantExams: state.questionCreate.allRelevantExams,
    questionPreviousExams:_.get(state,"questionCreate.questionPreviousExams",{}),
    questionSpecialPurposes: state.questionCreate.specialPurposes,
    allPreviousExams: state.questionCreate.allPreviousExams,
  };
};

const mapDispatchToProps = (dispatch: any) =>
  bindActionCreators(
    {
    //   setQuestionBenchmarks: questionActions.setQuestionBenchmarks,
    //   removeAllQuestionBenchmarks: questionActions.removeAllQuestionBenchmarks,
    //   editQuestionBenchmarks: questionActions.editQuestionBenchmarks,
    //   setForceQuestionBenchmarkUpdate:
    //     questionActions.setForceQuestionBenchmarkUpdate,
    //   addQuestionBenchmarkField: questionActions.addQuestionBenchmarkField,
    //   removeQuestionBenchmarkField:
    //     questionActions.removeQuestionBenchmarkField,
    //   setQuestionBenchmarkErrors: questionActions.setQuestionBenchmarkErrors,
    //   resetQuestionBenchmarks: questionActions.resetQuestionBenchmarks,
    //   initialiseQuestionBenchmarks:
    //     questionActions.initialiseQuestionBenchmarks,
      setPreviousExams:questionActions.setPreviousExam
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
  // @ts-ignore
)(withStyles(styles)(React.memo(PreviousYearQuestion)));
